import { isSupportedLocale } from '@horizon/i18n'
import type { Locale } from '@/types'

const STORAGE_KEY = 'horizon.admin.locale'
export const DEFAULT_ADMIN_LOCALE: Locale = 'fr'

const readStoredLocale = (): Locale => {
  if (typeof window === 'undefined') return DEFAULT_ADMIN_LOCALE

  try {
    const stored = window.localStorage.getItem(STORAGE_KEY)
    return isSupportedLocale(stored) ? stored : DEFAULT_ADMIN_LOCALE
  } catch {
    return DEFAULT_ADMIN_LOCALE
  }
}

let current = readStoredLocale()
const listeners = new Set<() => void>()

export const getAdminLocale = (): Locale => current

export const subscribeAdminLocale = (listener: () => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

/** Sets a supported locale, persists it when possible, and updates React subscribers. */
export const setAdminLocale = (value: string): Locale => {
  const next = isSupportedLocale(value) ? value : DEFAULT_ADMIN_LOCALE
  if (next === current) return current

  current = next
  if (typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(STORAGE_KEY, current)
    } catch {
      // Private browsing or a disabled storage policy must not block switching language.
    }
  }
  listeners.forEach(listener => listener())
  return current
}
